import { __awaiter } from 'tslib';
import { differentLocales } from '@abp/ng.core';
import { isDevMode } from '@angular/core';

let localeMap = {};
function registerLocale({ cultureNameLocaleFileMap = {}, errorHandlerFn = defaultLocalErrorHandlerFn, } = {}) {
    return (locale) => {
        localeMap = Object.assign(Object.assign({}, differentLocales), cultureNameLocaleFileMap);
        return new Promise((resolve, reject) => {
            return import(
            /* webpackMode: "lazy-once" */
            /* webpackChunkName: "locales"*/
            /* webpackInclude: /[/\\](ar|cs|en|en-GB|es|de|fi|fr|pt|tr|ru|hu|sl|zh-Hans|zh-Hant).js/ */
            /* webpackExclude: /[/\\]global|extra/ */
            `@angular/common/locales/${localeMap[locale] || locale}.js`)
                .then(resolve)
                .catch(error => {
                errorHandlerFn({
                    resolve,
                    reject,
                    error,
                    locale,
                });
            });
        });
    };
}
const extraLocales = {};
function storeLocaleData(data, localeId) {
    extraLocales[localeId] = data;
}
function defaultLocalErrorHandlerFn({ locale, resolve }) {
    return __awaiter(this, void 0, void 0, function* () {
        if (extraLocales[locale]) {
            resolve({ default: extraLocales[localeMap[locale] || locale] });
            return;
        }
        if (isDevMode) {
            console.error(`Cannot find the ${locale} locale file. You can check how can add new culture at https://docs.abp.io/en/abp/latest/UI/Angular/Localization#adding-a-new-culture`);
        }
        resolve();
    });
}

/**
 * Generated bundle index. Do not edit.
 */

export { defaultLocalErrorHandlerFn, registerLocale, storeLocaleData };

//# sourceMappingURL=abp-ng.core-locale.js.map